import { FC } from "react";

import TiledText from "@/components/BentoList/TiledText";
import { BentoTextElement } from "@/types";

const TiledBlockV5: FC<{ items: BentoTextElement[] }> = ({ items }) => {
  return (
    <div className="grid grid-cols-1 h-full w-full gap-xs">
      {items.map((item, index) => (
        <TiledText slideIndex={index} key={item.id} entry={item} />
      ))}
    </div>
  );
};
export default TiledBlockV5;
